import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicApplicationsAddDevice',
  props: {
    // applicationId: {
    //   type: Number,
    //   required: true,
    // },
  },
  data: function () {
    return {
      deviceUpdateDialog: false,
      selectedRows: [],
      selected: [],
      editAllFormDialog: false,
      selectOriginatorStep: true,
      addNew: false,
      finalStep: false,
      editedItem: {
        applicationId: parseInt(this.$route.params.applicationId)
      },
      originators: [],
      deviceTypes: [],
      originatorListLimit: 50
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])
  },
  mounted() {
    this.originatorFetchPlain();
  },
  destroyed() {
    this.$emit('close');
  },
  methods: {
    refreshList() {
      this.$emit('refreshList');
    },
    originatorFetchPlain() {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      NiotaClassicApiService.originatorsFetchPlain(this.originatorListLimit).then(res => {
        this.originators = res.data.originators;
      }).catch(() => {
        this.originators = [];
        this.$snack('Error fetching originators', 'error');
      }).finally(() => {
        this.isFetching = false;
      });
    },
    selectedOriginator(originator) {
      this.editedItem.originatorId = originator.id;
      this.originator = originator;
      this.datasourceType = this.originator.datasource.type;
      this.editedItem = cloneDeep(this.editedItem);
      this.selectOriginatorStep = false;
      this.finalStep = true;
      this.deviceTypeFetchPlain();
    },
    resetOriginator() {
      delete this.editedItem.originatorId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.firstStep = false;
      this.selectOriginatorStep = true;
      this.finalStep = false;
      this.addNew = false;
    },
    resetApplication() {
      delete this.editedItem.originatorId;
      delete this.editedItem.applicationId;
      this.originator = {};
      this.datasourceType = null;
      this.editedItem = cloneDeep(this.editedItem);
      this.selectOriginatorStep = false;
      this.finalStep = false;
    },
    deviceTypeFetchPlain() {
      NiotaClassicApiService.deviceTypeFetchPlain().then(res => {
        this.deviceTypes = res.data.devicetypes;
      }).catch(() => {
        this.deviceTypes = [];
        this.$snack(this.$i18n_t('NiotaClassic.Applications.form.errorFindingOriginators'), 'error');
      });
    }
  }
};